var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLedLocationActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C6.006 0 2.757 3.25 2.757 7.243c0 4.957 6.482 12.233 6.758 12.54.259.29.712.289.97 0 .276-.307 6.758-7.583 6.758-12.54C17.243 3.25 13.994 0 10 0zm0 10.887a3.648 3.648 0 01-3.644-3.644A3.648 3.648 0 0110 3.6a3.648 3.648 0 013.644 3.644A3.648 3.648 0 0110 10.887z",
    fill: "#FFA700"
  })));
}

export default SvgLedLocationActive;